import { UseQueryResult } from '@tanstack/react-query';
import { TabPanel } from '@cad-arc';
import { ResultsTab } from '../search-windows/types';
import { PaginationContextType } from './use-pagination';
import { ReactElement } from 'react';
import { ErrorBoundary } from '../monitoring/error-boundary';
import { SEARCH_RESULTS_EXPORTS_FOOTER_HEIGHT_PX, TOTAL_NON_RESULTS_HEIGHT_PX } from './constants';
import { ResultSelectionStore } from './use-observable-search-results-selection-store';
import { observer } from 'mobx-react-lite';
import { SearchResults } from './search-results';
import { FileExportHandlerType } from '../event-search/types';

export const SearchResultsTab = observer(function SearchResultsTab({
    tab,
    results,
    onClose,
    pagination,
    selection,
    searchQuery,
    executeSavedSearchQuery,
    onFileExport,
    isExportLoading,
    isCSVExportLoading,
    isEventSearch,
    header,
    children,
    allowConsolidatedExport,
}: Readonly<{
    tab: ResultsTab<unknown>;
    results?: { id: number }[];
    totalCount: number;
    onClose: () => void;
    pagination: PaginationContextType;
    selection?: ResultSelectionStore;
    searchQuery: UseQueryResult<unknown>;
    executeSavedSearchQuery: UseQueryResult<unknown>;
    onFileExport?: FileExportHandlerType;
    isExportLoading?: boolean;
    isCSVExportLoading?: boolean;
    isEventSearch?: boolean;
    header: ReactElement;
    children: ReactElement;
    allowConsolidatedExport?: boolean;
}>) {
    const showExportsFooter = results && selection?.anySelected;
    return (
        <ErrorBoundary
            name="SEARCH_RESULTS_TAB"
            actions={[{ children: 'Close tab', onClick: () => onClose() }]}
        >
            <TabPanel
                value={tab.title}
                key={tab.title}
                hasPadding={false}
                style={{
                    height: `calc(100% - ${
                        showExportsFooter
                            ? TOTAL_NON_RESULTS_HEIGHT_PX + SEARCH_RESULTS_EXPORTS_FOOTER_HEIGHT_PX
                            : TOTAL_NON_RESULTS_HEIGHT_PX
                    }px)`,
                    overflowY: 'auto',
                }}
            >
                <SearchResults
                    header={header}
                    searchQuery={searchQuery}
                    executeSavedSearchQuery={executeSavedSearchQuery}
                    results={results}
                    selection={selection}
                    pagination={pagination}
                    onFileExport={onFileExport}
                    isExportLoading={isExportLoading}
                    isCSVExportLoading={isCSVExportLoading}
                    allowConsolidatedExport={allowConsolidatedExport}
                    isEventSearch={isEventSearch}
                >
                    {children}
                </SearchResults>
            </TabPanel>
        </ErrorBoundary>
    );
});
